import "./polyfills";
import * as Pages from "@bd-pages";
import { Menu } from "../component/menu";
import { Notification } from "../component/notification";

Object.keys(Pages).forEach((key) => Pages[key]());
Menu();
Notification();
